<div #breadcrumbs class="breadcrumbs" [ngClass]="{ sticky }">
  <div class="container">
    <div *ngIf="crumbs.length" class="breadcrumbs__content" #widgetsContent>
      <div class="crumbs">
        @for (
          crumb of crumbs;
          track $index;
          let first = $first;
          let last = $last
        ) {
          @if (crumb.path) {
            <a
              class="crumb"
              [disabled]="last"
              [routerLink]="crumb.path"
              [queryParams]="crumb.queryParams"
              [data-ga-value]="'crumb-' + crumb.key"
            >
              <span [innerHTML]="crumb.label"></span>
            </a>
          } @else {
            @if (crumb.href) {
              <a
                class="crumb"
                [disabled]="last"
                [href]="crumb.href"
                [data-ga-value]="'crumb-' + crumb.key"
              >
                <span [innerHTML]="crumb.label"></span>
              </a>
            } @else {
              <a
                class="crumb"
                [disabled]="last"
                [data-ga-value]="'crumb-' + crumb.key"
              >
                <span [innerHTML]="crumb.label"></span>
              </a>
            }
          }

          @if (!last) {
            <mat-icon color="tertiary">chevron_right</mat-icon>
          }
        }
      </div>
    </div>
  </div>
</div>
